/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CPUStat,
    CPUStatFromJSON,
    CPUStatFromJSONTyped,
    CPUStatToJSON,
    IOStat,
    IOStatFromJSON,
    IOStatFromJSONTyped,
    IOStatToJSON,
    NetStat,
    NetStatFromJSON,
    NetStatFromJSONTyped,
    NetStatToJSON,
    RAMStat,
    RAMStatFromJSON,
    RAMStatFromJSONTyped,
    RAMStatToJSON,
} from './';

/**
 * 
 * @export
 * @interface Stats
 */
export interface Stats {
    /**
     * 
     * @type {Array<CPUStat>}
     * @memberof Stats
     */
    cpu: Array<CPUStat>;
    /**
     * 
     * @type {Array<RAMStat>}
     * @memberof Stats
     */
    ram: Array<RAMStat>;
    /**
     * 
     * @type {{ [key: string]: Array<NetStat> | undefined; }}
     * @memberof Stats
     */
    net: { [key: string]: Array<NetStat> | undefined; };
    /**
     * 
     * @type {Array<IOStat>}
     * @memberof Stats
     */
    io: Array<IOStat>;
}

export function StatsFromJSON(json: any): Stats {
    return StatsFromJSONTyped(json, false);
}

export function StatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cpu': ((json['cpu'] as Array<any>).map(CPUStatFromJSON)),
        'ram': ((json['ram'] as Array<any>).map(RAMStatFromJSON)),
        'net': json['net'],
        'io': ((json['io'] as Array<any>).map(IOStatFromJSON)),
    };
}

export function StatsToJSON(value?: Stats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cpu': ((value.cpu as Array<any>).map(CPUStatToJSON)),
        'ram': ((value.ram as Array<any>).map(RAMStatToJSON)),
        'net': value.net,
        'io': ((value.io as Array<any>).map(IOStatToJSON)),
    };
}


